import styled from 'styled-components'

import { Button } from '@/ui/atoms/button'
import { Flex } from '@/ui/atoms/flex'
import { HeadlineText } from '@/ui/atoms/headline-text'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const SrpHeaderAndFilterContainer = styled(Flex)(
  ({ theme }) => `
    display: flex;
    flex-direction: column-reverse;
    ${MEDIA_QUERIES(theme).medium} {
      flex-direction: column;
    }
  `
)

export const SrpHeaderContainer = styled(Flex)(
  ({ theme }) => `
  flex-direction: column;
  gap: ${theme.spacing.default};
  margin-top: ${theme.spacing.default};
  `
)

type SrpHeaderSearchTitleProps = { isMapView: boolean }
export const SrpHeaderSearchTitle = styled(HeadlineText)<SrpHeaderSearchTitleProps>(
  ({ theme, isMapView }) => `
  align-self: flex-start;

  ${isMapView ? 'display: none;' : ''}
  max-width: 100%;
  overflow: hidden;
  padding: 0 ${theme.spacing.default} ${theme.spacing.defaultSmall} 0;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${MEDIA_QUERIES(theme).medium}{
    display: block;
    color: ${theme.colors.grey.primary};
    padding: 0 ${theme.spacing.default} ${theme.spacing.defaultSmall} 0;

  }
`
)

export const SaveSearchButton = styled(Button)(
  ({ theme }) => `
   svg {
    color: ${theme.colors.purple.light1};
    margin-right: ${theme.spacing.defaultSmall};
    height: ${theme.spacing.large};
    width: auto;
  }
`
)
